@if (options.length) {
  <div>
    <mat-label>{{title | translate}}</mat-label>
    <mat-select [(value)]="selectedOption" (selectionChange)="onSortChange()">
      @if (!selectedOption) {
        <mat-option translate>None</mat-option>
      }
      @for (option of options; track option) {
        <mat-option [value]="option['value']">{{option['title'] | translate}}</mat-option>
      }
    </mat-select>
  </div>
}
